import { Injectable } from "@angular/core";
import { LocalStoreService } from "./local-store.service";
import { Router } from "@angular/router";
import { of, throwError } from "rxjs";
import { delay } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class AuthService {
  //Only for demo purpose
  authenticated = false;
  
  private readonly token = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoiKzI1NDcxNzE3NDk4NSIsImlhdCI6MTY5NTIzODc3MX0.ET2uBIUH6GftXT--589g3S1_R013FiWTPFLQw50W5Q4`;
  private user = {};

  constructor(private store: LocalStoreService, private router: Router) {
    this.checkAuth();
  }

  checkAuth() {
    this.authenticated = !!this.store.getItem('demo_login_status');
  }

  getuser() {
    return of(this.user);
  }

  signin(credentials) {
    if (credentials.email !== 'verido@ntizologistics.com' || credentials.password !== 'test123') {
      return throwError(new Error("Email and/or password is incorrect"));
    }
    this.authenticated = true;
    this.user = {};
    this.store.setItem("demo_login_status", true);
    return of({ accessToken: this.token }).pipe(delay(1500));
  }
  signout() {
    this.authenticated = false;
    this.user = {};
    this.store.setItem("demo_login_status", false);
    this.router.navigateByUrl("/sessions/signin");
  }
}
